import { render, staticRenderFns } from "./RestaurantsN.vue?vue&type=template&id=7a3aff36"
import script from "./RestaurantsN.vue?vue&type=script&lang=js"
export * from "./RestaurantsN.vue?vue&type=script&lang=js"
import style0 from "./RestaurantsN.vue?vue&type=style&index=0&id=7a3aff36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports